import Router from 'vue-router'
import Vue from 'vue'
import protectedRoutes from '@/router/protected'
import publicRoutes from '@/router/public'
import store from '@/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    scrollBehavior() {
        return window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    routes: [
        ...publicRoutes,
        ...protectedRoutes
    ]
})

router.beforeEach((to, _, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const autenticacao = store.getters.getAutenticacao

        if (autenticacao === null || autenticacao.token === null) {
            const customer = store.getters.getCustomer

            if (customer) {
                next(`/login/${customer.link}`)
            }

            next('/401')
        }
    }

    if (store.getters.getShowExitFormConfirmation) {
        store.dispatch('notification/createNotification', {
            type: 'dialog',
            color: 'danger',
            title: 'Atenção',
            message: 'As informações não salvas serão perdidas. Deseja realmente sair?',
            confirm: async () => {
                store.dispatch('unsetShowExitFormConfirmation')
                next()
            },
        })
    } else {
        next()
    }
})

export default router